<template>
        <v-card
        :color=getColor()
        dark
        height="100%">
            <v-card-title primary-title>
                <div>
                    <div class="headline">
                        <v-icon v-if="isOpenSource()">
                            fab fa-osi
                        </v-icon>
                        {{Team.name}}
                    </div>
                </div>

                <v-layout align-end justify-end>
                    <v-card-actions justify-end>
                        <v-layout>
                            <v-flex>
                                <a v-if="Team.twitter" :href="Team.twitter">
                                        <v-icon>fab fa-twitter</v-icon>
                                </a>
                            </v-flex>
                            <v-flex>
                                <a v-if="Team.site" :href="Team.site">
                                        <v-icon>fa fa-globe</v-icon>
                                </a>
                            </v-flex>
                        </v-layout>
                    </v-card-actions>
                </v-layout>
            </v-card-title>
            <v-card-text>
                <p>
                {{Team.description}}
                </p>
            </v-card-text>
            <v-flex align-end>
            </v-flex>
        </v-card>
</template>

<script>
export default {
    name: 'Team',
    props:[
        'Team'
    ],
    methods:{
        getColor() {
            if(this.Team.color){
                return this.Team.color;
            }
            if(this.Team.type === 'opensource'){
                return '#5a2aac'
            } else if (this.Team.type === 'mine') {
                return '#FAC700'
            } else {
                return '#000000'
            }
        },
        isOpenSource(){
            if(this.Team.type === 'opensource'){
                return true;
            }
            return false;
        },
    }
}
</script>

<style scoped>
p{
    font-size:1.5em;
}
</style>



